import Common from '../../../../Common';

const Pricelist = class extends Common {
	browse = (companyId: id) =>
		this.get(`/company/${companyId}/selfservice/subscription/pricelist`)
}

export default Pricelist
